export const AUTH_CODE = {
    LOGIN: -100,
    REAL_NAME: -150,
    WECHAT: -151,
    REAL_NAME_FAILED: -152,
}

export const ENABLED_AUTH_CODES = [
    AUTH_CODE.LOGIN,
    AUTH_CODE.REAL_NAME,
    AUTH_CODE.WECHAT,
    AUTH_CODE.REAL_NAME_FAILED,
]

const AUTH_CODE_PRIORITY = {
    [AUTH_CODE.LOGIN]: 4,
    [AUTH_CODE.REAL_NAME]: 3,
    [AUTH_CODE.REAL_NAME_FAILED]: 2,
    [AUTH_CODE.WECHAT]: 1,
}

export function normalizeAuthCode(code) {
    const value = Number(code)
    return AUTH_CODE_PRIORITY[value] ? value : 0
}

export function isAuthRequiredCode(code) {
    return Boolean(AUTH_CODE_PRIORITY[Number(code)])
}

export function isEnabledAuthCode(code) {
    return ENABLED_AUTH_CODES.indexOf(Number(code)) > -1
}

export function isBlockingAuthCode(code) {
    return isEnabledAuthCode(code) && Number(code) !== AUTH_CODE.REAL_NAME_FAILED
}

export function getServerAuthStore() {
    if (typeof window !== 'undefined') {
        return null
    }

    const storage = global.__ZQCF_AUTH_CONTEXT__
    return storage ? storage.getStore() : null
}

export function getServerAuthRequiredCode() {
    const store = getServerAuthStore()
    return store ? store.authRequiredCode || 0 : 0
}

export function setServerAuthRequiredCode(code) {
    const store = getServerAuthStore()
    if (!store) {
        return
    }

    const normalizedCode = normalizeAuthCode(code)
    if (!normalizedCode) {
        return
    }

    const currentCode = store.authRequiredCode || 0
    if (!currentCode || AUTH_CODE_PRIORITY[normalizedCode] > AUTH_CODE_PRIORITY[currentCode]) {
        store.authRequiredCode = normalizedCode
    }
}
